export const NAVBAR_MENU_BURGER_DEFAULTS_V2 = {
  mobileJustify: 'end',
  color: '#171717',
  size: 16,
};
